import { render, staticRenderFns } from "./flourtypes.vue?vue&type=template&id=6d495d3a&scoped=true&"
import script from "./flourtypes.vue?vue&type=script&lang=js&"
export * from "./flourtypes.vue?vue&type=script&lang=js&"
import style0 from "./flourtypes.vue?vue&type=style&index=0&id=6d495d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d495d3a",
  null
  
)

export default component.exports